import { useState } from 'react';
import { ProTable } from '@ant-design/pro-components';
import { Button, theme, Space } from 'antd';
import {
    useGetThirdPartyBillingBatchQuery,
    useGetThirdPartyBillingInvoiceNamesQuery,
    useGetAllCustomerUidQuery,
    useGetUserQuery,
} from '../../../features/api/apiSlice';
import { ThirdPartyBillingBatchColumns } from './ThirdPartyBillingBatchColumns';
import DownloadModal from './DownloadModal';
import { useSelector } from 'react-redux';
function ThirdPartyBillingBatchPage () {
    const { token } = theme.useToken();
    const [searchData, setSearchData] = useState({});
    const { data, isLoading, isFetching, refetch } = useGetThirdPartyBillingBatchQuery({...searchData});
    const { data: billingInvoiceNames } = useGetThirdPartyBillingInvoiceNamesQuery({ source_type: 1 }, { refetchOnMountOrArgChange: true });
    const { data: customerUidData } = useGetAllCustomerUidQuery({}, { refetchOnMountOrArgChange: true });
    const { data: userData} = useGetUserQuery({}, { refetchOnMountOrArgChange: true });
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [downloadModalOpen, setDownloadModalOpen] = useState(false);
    const columns = ThirdPartyBillingBatchColumns(billingInvoiceNames, customerUidData, userData);
    const currUser = useSelector((state) => state.auth.user);
    const rowSelection = {
        selectedRowKeys,
        onChange: (selectedRowKeys) => {
            setSelectedRowKeys(selectedRowKeys);
        },
    };
    const downloadBySelectButtonHandler = () => {
        setDownloadModalOpen(true);
    }
    return (
        <>
        <ProTable
            search={{
                span: { xs: 24, sm: 12, md: 8, lg: 8, xl: 8, xxl: 8 },
                labelWidth: 'auto',
                defaultCollapsed: false,
                style: {
                    maxWidth: 'none',
                    background: token.colorFillAlter,
                    borderRadius: token.borderRadiusLG,
                    padding: 24,
                },
            }}
            tableAlertOptionRender={() => {
                return (
                    <Space size='small' >
                        {currUser.button_permission?.includes('third_party_download_billing_batch') && <Button type="link" loading={false} onClick={() => { downloadBySelectButtonHandler()}}>下载数据</Button>}
                        <Button type="link" onClick={() => { setSelectedRowKeys([]) }}>取消选择</Button>
                    </Space>
                )
            }}
            request={(params, sort) => {
                setSearchData({ ...params, sort });
            }}
            rowKey={record => record.id}
            dataSource={data?.results}
            loading={isLoading || isFetching}
            columns={columns}
            rowSelection={rowSelection}
            pagination={{
                defaultPageSize: 10,
                showSizeChanger: true,
                pageSizeOptions: ['10', '20', '50', '100'],
                total: data?.count,
            }}
            scroll={{ x: 'max-content' }}
            options={{
                reload: () => refetch(),
            }}
        />
        <DownloadModal
            open={downloadModalOpen}
            setOpen={setDownloadModalOpen}
            data={selectedRowKeys}
        />
        </>
    )
}

export default ThirdPartyBillingBatchPage;